import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=7dfce6ca&scoped=true&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfce6ca",
  null
  
)

export default component.exports